<template>
  <nav class="bg-light pb-2 pb-lg-0">
    <div class="navbar navbar-expand-lg navbar-light justify-content-start">
      <button
        :class="['navbar-toggler mr-3', { collapsed: !expanded }]"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        :aria-expanded="expanded ? 'true' : 'false'"
        aria-label="Toggle navigation"
        @click.prevent="expanded = !expanded"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <router-link
        class="navbar-brand py-0"
        :to="{ name: constants.ROUTE_HOME }"
        >{{ $t("title") }}</router-link
      >

      <div
        :class="['navbar-collapse collapse', { show: expanded }]"
        id="navbarSupportedContent"
      >
        <ul class="navbar-nav mr-auto">
          <template v-if="$store.getters.loggedUser">
            <router-link
              tag="li"
              class="nav-item"
              active-class="active"
              :to="{ name: constants.ROUTE_FOOD }"
              ><a class="nav-link" @click="collapseNav">{{
                $t("navigation." + constants.ROUTE_FOOD)
              }}</a></router-link
            >
            <router-link
              tag="li"
              class="nav-item"
              active-class="active"
              :to="{ name: constants.ROUTE_CATEGORIES }"
              ><a class="nav-link" @click="collapseNav">{{
                $t("navigation." + constants.ROUTE_CATEGORIES)
              }}</a></router-link
            >
          </template>
        </ul>

        <div class="d-none d-lg-block">
          <spjz-search-bar />
        </div>

        <ul class="navbar-nav">
          <template v-if="$store.getters.loggedUser">
            <li class="nav-item" @click="collapseNav">
              <a
                class="nav-link"
                @click.prevent="$store.commit('logoutUser')"
                href="/"
                >{{ $t("navigation." + constants.ROUTE_LOGOUT) }}</a
              >
            </li>
          </template>
          <template v-else>
            <router-link
              tag="li"
              class="nav-item"
              active-class="active"
              :to="{ name: constants.ROUTE_LOGIN }"
              ><a class="nav-link" @click="collapseNav">{{
                $t("navigation." + constants.ROUTE_LOGIN)
              }}</a></router-link
            >
            <router-link
              tag="li"
              class="nav-item"
              active-class="active"
              :to="{ name: constants.ROUTE_REGISTER }"
              ><a class="nav-link" @click="collapseNav">{{
                $t("navigation." + constants.ROUTE_REGISTER)
              }}</a></router-link
            >
          </template>
          <spjz-language-switch />
        </ul>
      </div>
    </div>

    <div class="container-fluid d-lg-none">
      <spjz-search-bar />
    </div>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";
import * as constants from "./../constants";
import LanguageSwitch from "./LanguageSwitch";
import SearchBar from "./search/SearchBar";

export default {
  name: "Navigation",
  components: {
    "spjz-language-switch": LanguageSwitch,
    "spjz-search-bar": SearchBar
  },
  data() {
    return {
      constants,
      expanded: false
    };
  },
  methods: {
    collapseNav() {
      this.expanded = false;
    }
  }
};
</script>

<style scoped lang="scss">
@import "./../assets/scss/variables";

.navbar-brand {
  font-family: "Allura", cursive;
  font-size: 36px;
  line-height: 40px;
  text-shadow: $color-primary 0 0 2px;
}
.input-group-prepend {
  .input-group-text {
    background-color: white;
  }
  & + input {
    border-left: none;
  }
}
@media (max-width: 991px) {
  .navbar-collapse {
    overflow: hidden;
    display: block !important;
    max-height: 0 !important;
    transition: max-height 300ms ease-in-out;

    &:not(.show) {
      padding: 0;
      border: none;
    }

    &.show {
      max-height: 500px !important; //this must have tobe higher than the max height of the dropdown list
    }
  }
}
</style>
